import { render, staticRenderFns } from "./TablePlayer.vue?vue&type=template&id=48c27c86&scoped=true&lang=html&"
import script from "./TablePlayer.vue?vue&type=script&lang=js&"
export * from "./TablePlayer.vue?vue&type=script&lang=js&"
import style0 from "./TablePlayer.vue?vue&type=style&index=0&id=48c27c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c27c86",
  null
  
)

export default component.exports